import { NeedDto } from '@act/shared/data-transfer-objects';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import useNeedDetailDialog from 'react-components/dialog-forms/hooks/use-need-detail-dialog';
import { needsSelectors } from 'redux/slices/needs.slice';
import { generateDatadogTrackingProps } from 'toolkit/environment/environment/user-monitoring';
import NeedHistory from './components/history/need-history';
import { Button, IconMessage } from '@act/storybook';

interface NeedDetailsProps {
  need: NeedDto;
}

const NeedDetails = ({ need }: NeedDetailsProps) => {
  const [expandDetails, setExpandDetails] = useState<boolean>(false);
  const history = needsSelectors.useSelectNeedHistoryEntriesByIds(
    need.historyEntryIds
  );

  const openNeedDetailsDialog = useNeedDetailDialog();

  return (
    <Accordion
      expanded={expandDetails}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        border: 'none',
        '&.MuiAccordion-root': {
          boxShadow: 'none',
          '&::before': { background: 'none' },
        },
        '&.Mui-expanded': { margin: 0, border: 'none' },
      }}
      square
      disableGutters
    >
      <AccordionSummary
        expandIcon={
          <IconButton
            onClick={() => setExpandDetails(!expandDetails)}
            {...generateDatadogTrackingProps('needs-details-card-expand')}
          >
            <ExpandMoreIcon />
          </IconButton>
        }
        sx={{
          order: 2,
          padding: '0 8px',
          '&:hover': { cursor: 'default !important' },
        }}
      >
        <Button
          onClick={() =>
            openNeedDetailsDialog({
              needId: need.id,
            })
          }
          sx={{
            margin: '-10px 0',
          }}
          variant="text"
          {...generateDatadogTrackingProps('needs-details-card-view-details')}
        >
          <Typography variant="labelLarge">View details</Typography>
        </Button>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '8px 16px' }}>
        <Typography variant="titleMedium">History</Typography>
        {!history?.length && (
          <IconMessage
            message="No history found"
            iconName="DropSlash"
            iconColor="primary"
          />
        )}
        {history?.length && <NeedHistory need={need} />}
      </AccordionDetails>
    </Accordion>
  );
};

export default NeedDetails;
